/**
 * Placeholder until Brand Voice has a real documentation page (root of the docs site is fine
 * for now, per review — this becomes a real deep link once that page exists). Kept as its own
 * module rather than inline at each call site, so pointing "Learn more" and the editor's intro
 * link at the real page later is a one-line change instead of a copy hunt through JSX.
 */
export const BRAND_VOICE_DOCS_URL = '#'
